import {Component, Input, OnInit} from '@angular/core';
import { NotificationStateService } from '../../../services/notification-state.service';
import {AssetsService} from '../../../services/assets.service';
import {NotificationState} from '../../../models/notification-state';

@Component({
  selector: 'app-insurer-failed-data-authorization',
  templateUrl: './insurer-failed-data-authorization.component.html',
  styleUrls: ['./insurer-failed-data-authorization.component.scss']
})
export class InsurerFailedDataAuthorizationComponent implements OnInit {

  @Input() notificationState: NotificationState;
  translationComponentKey = 'REGISTRATION_FAILED';

  constructor(private notificationStateService: NotificationStateService,
              private assetsService: AssetsService) {
  }

  get status(): any {
    return this.notificationState.registrationFailedStatus;
  }

  ngOnInit() {
    this.sendMetric();
  }

  get imageUrl(): string {
    return this.assetsService.informationDialogImageSrc;
  }

  public confirm(): void {
    window.location.href = 'https://kioskpolis.pl/';
  }

  private sendMetric(): void {
    this.notificationStateService.sendNotificationComponentMetric('InsurerFailedDataAuthorizationComponent', { status: this.status });
  }
}
